import { faCircleNotch, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BottomSheet from "components/reusable/BottomSheet";
import Toolbar from "components/Toolbar";
import { Button } from "flowbite-react";
import useToastContext from "hooks/useToastContext";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { apiGet } from "utils/apiFetch";
import pathObj from "utils/apiPath";

function SmartfinPayments() {
  const { t } = useTranslation();
  const notification = useToastContext();
  const navigate = useNavigate();
  const [showAddNewSmartfinPayment, setShowAddNewSmartfinPayment] = useState(false);

  const [finishedPayments, setFinishedPayments] = useState(null);

  const getFinishedPayments = async () => {
    try {
      const response = await apiGet(pathObj.finishedSmartfinTransactions);
      if (response.data.data.success) {
        setFinishedPayments(response.data.data.lists);
      } else {
        setFinishedPayments([]);
        notification.error(response.data.message);
      }
    } catch (err) {}
  };

  useEffect(() => {
    getFinishedPayments();
  }, []);

  const { register, handleSubmit } = useForm({ mode: "onChange", shouldFocusError: true, defaultValues: {} });
  const onNewPaymentSubmit = async (data) => {
    navigate("/payments/smartfin/pending-payment/" + data.order_number);
  };

  return (
    <>
      <Toolbar title={t("SMARTFIN_PAYMENTS")} showBackBtn={true} />
      <div>
        <div className="flex w-full justify-center">
          <div className="container grid grid-cols-3 xl:grid-cols-4 gap-5 mx-4">
            <div className={`relative col-span-3 mx-4`}>
              
            </div>
            <div className="col-span-3 xl:col-span-1 flex justify-center mt-5 xl:mt-0 w-full">
              <Button
                className="bg-card p-2 h-[4.5rem] w-full md:w-[20rem] gap-2 col-span-1 rounded-3xl"
                onClick={() => {
                  setShowAddNewSmartfinPayment(true);
                }}
              >
                <FontAwesomeIcon icon={faPlus} className="card-icon" />
                <span className="text-lg font-medium">{t("NEW_PAYMENT")}</span>
              </Button>
            </div>
            <div className="col-span-3 mt-5">
              <div className="font-medium text-lg my-5">{t("FINISHED_PAYMENTS")}</div>
              {!finishedPayments && (
                <div className="flex w-full justify-center">
                  <FontAwesomeIcon icon={faCircleNotch} className="text-xl animate-spin h-[15rem]" />
                </div>
              )}
              {finishedPayments &&
                finishedPayments.map((it, idx) => (
                  <div key={it.order_number} className="bg-card p-0 mx-1 text-white mb-3">
                    <div className="flex justify-between items-center p-4">
                      <div className="flex justify-start items-center gap-2">
                        <img src="/images/E-Albania.svg" className="w-[4rem] h-[4rem]" alt="" />
                        <div className="flex flex-col">
                          <span className="font-medium">{it.service_name}</span>
                          <span className="text-sm">{it.order_number}</span>
                        </div>
                      </div>
                      <span className={`font-medium ${it.status === "completed" ? "text-green-700" : ""}`}>{t(it.status)}</span>
                    </div>
                    <div className="h-[3rem] bg-primary flex justify-between items-center rounded-b-2xl">
                      <div>
                        {it.invoice && (
                          <Link to={it.invoice} target="_blank" className="text-white font-medium ms-4">
                            {t("DOWNLOAD_INVOICE")}
                          </Link>
                        )}
                      </div>
                      <div className="font-medium px-5">ALL {it.amount}</div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
      {showAddNewSmartfinPayment && (
        <BottomSheet
          open={showAddNewSmartfinPayment}
          onClose={() => {
            setShowAddNewSmartfinPayment(false);
          }}
          title={t("NEW_SMARTFIN_PAYMENT")}
        >
          <form onSubmit={handleSubmit(onNewPaymentSubmit)}>
            <div className="text-lg font-medium mb-2">{t("ORDER_NUMBER")}</div>
            <input
              type="text"
              id="order_number"
              className="inputform text-heading text-sm rounded-base block w-full px-3 py-2.5 shadow-xs placeholder:text-body"
              onKeyDown={(e) => {
                e.target.value = e.target.value.trim();
              }}
              {...register("order_number", {
                required: "",
              })}
            />

            <div className="w-full mt-5">
              <button className="btn btn_theme w-full text-white" type="submit">
                {t("PAY")}
              </button>
            </div>
          </form>
        </BottomSheet>
      )}
    </>
  );
}

export default SmartfinPayments;
